// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PDPA_wrapper__1o8VK","content":"PDPA_content__2Ne8K","link":"PDPA_link__3bWlj","button":"PDPA_button__Q2CEB"};